var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"login otp d-flex flex-column flex-lg-row flex-column-fluid bg-white",attrs:{"id":"kt_sign_iv"}},[_c('div',{staticClass:"login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"})])])
}]

export { render, staticRenderFns }